export default function PrivacyPageBody() {
  return (
    <div className="container">
      <main role="main" className="pb-3">
        <h1>Privacy</h1>

        <p>Use this page to detail your site's privacy policy.</p>
      </main>
    </div>
  )
}
